"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initializeSession = initializeSession;
const client_1 = require("../../session/client/index.js");
const verify_session_1 = require("./verify-session");
async function initializeSession(params) {
    const response = await fetch("/api/sessions", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        credentials: "include",
        body: JSON.stringify(params),
    });
    if (!response.ok) {
        throw response;
    }
    const verifySessionResponse = await (0, verify_session_1.verifySession)();
    if (verifySessionResponse) {
        return;
    }
    const data = await response.json();
    if (data.sessionId) {
        (0, client_1.setRuntimeSessionId)(data.sessionId);
    }
}
